import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-section-accordion',
  templateUrl: './app-section-accordion.component.html',
  styleUrls: ['./app-section-accordion.component.css']
})
export class AppSectionAccordionComponent implements OnInit {

  @Input() sectionInfo;

  constructor() { }

  ngOnInit(): void {
  }

  openPdf(pdfId){
    /* this.router.navigateByUrl('pdf-view/'+pdfId); */
  }

  openAction(action){
    debugger;
  }

}
